import { createRouter, createWebHistory, createMemoryHistory } from "vue-router";
import TheHomePage from "@/pages/TheHomePage.vue";
import TheServicesPage from "@/pages/TheServicesPage.vue";
import { useScrollStore } from "@/stores/storeScroll";

export const routes = [
		{
			path: "/",
			name: "home",
			component: TheHomePage,
		},
		{
			path: "/services/",
			name: "services",
			component: TheServicesPage,
			meta: { requiresAuth: true },
		},
		// {
		// 	path: "/:pathMatch(.*)*",
		// 	name: "404",
		// 	component: TheNotFindPage,
		// },
	]

const isServer = typeof window === "undefined";

const scrollPositions = {};

export const router = createRouter({
	history: isServer ? createMemoryHistory(import.meta.env.BASE_URL) : createWebHistory(import.meta.env.BASE_URL),
	routes,
	scrollBehavior(to, from, savedPosition) {
		const storeScroll = useScrollStore();
		const headerOffset = storeScroll.header?.offsetHeight || 100;

		if (to.hash) {
			return {
				el: to.hash,
				behavior: "smooth",
				top: headerOffset,
			};
		}

		if (savedPosition) {
			return savedPosition;
		}

		const savedPos = scrollPositions[to.fullPath];
		if (savedPos) {
			return savedPos;
		}

		return { top: 0 };
	},
});

router.beforeEach((to, from) => {
	
	scrollPositions[from.fullPath] = {
		left: window.scrollX,
		top: window.scrollY,
	};
});

// router.beforeEach((to, from, next) => {
// 	const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
// 	const storeRequests = useRequestsStore();
// 	if (requiresAuth && !storeRequests.isAuthenticated) {
// 		next("/");
// 	} else {
// 		next();
// 	}
	
// });

export default router;
